<script setup>
import axios  from "axios";
axios.defaults.baseURL = 'https://qlipper.jp/';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
  <v-card class="d-flex flex-column mx-auto my-6 flat" width="374" color="#fff">
    <v-card-title class="d-flex justify-center pa-0 mt-6"
      ><h2>ログイン</h2></v-card-title>
    <v-card-text class="d-flex justify-center flex-column">
      <p style="color:red;" v-if="message != ''">{{ message }}</p>
      <v-form class="mx-9" ref="form" v-model="valid">
        <v-text-field
          placeholder="メールアドレス"
          outlined
          dense
          v-model="login_id"
          :rules="mailRules"
        ></v-text-field>
        <v-text-field
          placeholder="パスワード"
          outlined
          dense
          v-model="password"
          :rules="pwRules"
          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          :type="show1 ? 'text' : 'password'"
          @click:append="show1 = !show1"
        ></v-text-field>
        <a style="width:100%;display:block;font-size:1.5rem;text-align:center;margin-bottom:10px;" href="https://qlipper.jp/chatreg.html">新規会員登録はこちら</a>
        <div class="text-center">
          <v-btn class="primary" :disabled="!valid" @click="login">ログイン</v-btn>
        </div>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      show1   : false,
      message : "",
      login_id : "",
      password : "",
      valid: false,
      mailRules: [
        (v) => !!v || "メールアドレスを入力してください",
        v => /.+@.+\..+/.test(v) || '形式が正しくありません。メールアドレスを入力してください',],
      pwRules: [(v) => !!v || "パスワードを入力してください"],
    };
  },
  methods: {
    validate() {
      this.$refs.form.validate();
    },
    login : async function(){
        var params = new URLSearchParams();
        params.append("login_id",this.login_id);
        params.append("password",this.password);
        await axios.post("/api/session/login",params)
        .then(response => {
            if(response.data == true)
            {
                this.$router.push("/");
            }
            else
            {
                this.message = "ログインできませんでした。メールアドレスとパスワードを確認してください";
            }
        })
        .catch((error) => {
            console.error('失敗です', error);
        });
    },
    forgetPw() {
      // パスワードを忘れた時の処理
    },
  },
};
</script>
